import React from 'react'
import { connect } from 'react-redux'
import { photoUploadRequest } from '../../../../action/photo-actions'
import { boundaryCreateRequest } from '../../../../action/boundary-actions'
class SaveBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      uploading: false,
      saved: false,
      boundaryName: `Boundary-${props.boundaries.length}`
    }
    this.idleListener = null
    this.setImage = this.setImage.bind(this)
    this.getBlob = this.getBlob.bind(this)
  }

  componentDidMount() {
    const { mapReference } = this.props,
      { setImage } = this
    this.setImage()
    this.idleListener = google.maps.event.addListener(mapReference, 'tilesloaded', function () {
      setImage()
    })
  }

  componentWillUnmount() {
    this.idleListener.remove()
    this.idleListener = null
  }

  setImage() {
    const prevCanvas = document.getElementById('boundary-preview-canvas'),
      context = prevCanvas.getContext('2d')
    context.setTransform(1, 0, 0, 1, 0, 0)
    context.clearRect(0, 0, prevCanvas.width, prevCanvas.height)
    context.restore()
    const divs = document.getElementsByTagName('img'),
      tiles = []

    for (let i = 0; i < divs.length; ++i) {
      const ele = divs[i]
      if (ele.offsetWidth >= 256) {
        tiles.push(ele)
      }
    }
    tiles.sort((a, b) => {
      const aOrder = a.getAttribute('drawOrder') ? parseInt(a.getAttribute('drawOrder')) : 0,
        bOrder = b.getAttribute('drawOrder') ? parseInt(b.getAttribute('drawOrder')) : 0
      return aOrder - bOrder
    })

    tiles.forEach(tile => {
      const image = new Image()
      image.crossOrigin = 'anonymous'
      image.alt = ''
      image.src = tile.src
      image.addEventListener('load', () => {
        const rect = tile.getBoundingClientRect()
        context.drawImage(image, rect.x, rect.y, rect.width + 1, rect.height + 1)
      })
    })
  }

  getBlob() {
    const canvas = document.getElementById('boundary-preview-canvas')
    return new Promise(resolve => {
      canvas.toBlob(blob => {
        resolve(blob)
      })
    })
  }

  saveBoundary() {
    this.setState({ uploading: true })
    const { activeLayers, boundaryCreateRequest, mapReference, photoUploadRequest } = this.props
    const canvasBlob = this.getBlob()
      .then(blob => {
        const data = new FormData(),
          photoInfo = {
            typeId: 5,
            name: `${this.state.boundaryName}-photo`
          }
        data.append('photo', blob)
        data.append('photoInfo', JSON.stringify(photoInfo))
        photoUploadRequest(data)
          .then(res => {
            const bounds = mapReference.getBounds(),
              boundsObj = bounds.toJSON(),
              layers = activeLayers.map(id => { return { layerId: id } }),
              boundaryData = {
                name: this.state.boundaryName,
                photoId: res.id,
                mapBoundaryLayer: layers,
                latitudeUpperLeft: boundsObj.north,
                longitudeUpperLeft: boundsObj.west,
                latitudeLowerRight: boundsObj.south,
                longitudeLowerRight: boundsObj.east,
                mapBoundaryCamera: {
                  bearing: mapReference.getHeading(),
                  targetLatitude: bounds.getCenter().lat(),
                  targetLongitude: bounds.getCenter().lng(),
                  tilt: mapReference.getTilt(),
                  zoom: mapReference.getZoom(),
                }
              }

            boundaryCreateRequest(boundaryData)
              .then(() => {
                this.setState({ saved: true })
              })
          })
      })
      .catch(err => console.log('Boundary Creation Error:', err))
  }

  setName(e) {
    this.setState({ boundaryName: e.target.value })
  }

  render() {
    const { hidePopout, mapReference } = this.props
    return (
      <div style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        {!this.props.leftToolBar && <div className='popout-close' onClick={hidePopout}></div>}
        <div className='popout-header'>Add Favorite Location</div>
        <div className='popout-boundary-preview'>
          <canvas id='boundary-preview-canvas'
            width={mapReference.getDiv().offsetWidth}
            height={mapReference.getDiv().offsetHeight}
            className='center'
            style={{
              width: `415px`,
              height: `200px`,
              left: '49%'
            }}>
          </canvas>
        </div>
        <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
          <label>
            Location Name:
          </label>
          <input
            className='location-name-textfield'
            type='text'
            onChange={this.setName.bind(this)}
            value={this.state.boundaryName}
            style={{ width: '95%', marginTop: '5px' }}
          ></input>

        </div>

        <div className='popout-boundary-button-container'>
          <button className='popout-boundary-button'
            onClick={hidePopout}
            style={{ width: this.props.leftToolBar ? '50%' : '20%', backgroundColor: 'gray', marginRight: this.props.leftToolBar ? '10px' : '0' }}>CANCEL</button>
          <button className='popout-boundary-button'
            onClick={this.saveBoundary.bind(this)}
            style={{ width: this.props.leftToolBar ? '50%' : '70%' }}>SAVE LOCATION</button>
        </div>
        {
          this.state.uploading && !this.state.saved ? (
            <div className='dialog-loading-overlay' style={{ height: '100%' }}></div>
          ) : null
        }
        {
          this.state.saved ? (
            <div style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0, backgroundColor: 'black' }}>
              <div className='center'>
                <p className='popout-boundary-saved'>Boundary Saved.</p>
                <button className='popout-boundary-button horizontal-center'
                  onClick={hidePopout}
                  style={{ width: '75%', backgroundColor: 'gray', marginTop: '20px' }}>CLOSE</button>
              </div>
            </div>
          ) : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  activeLayers: state.userSettings.find(setting => setting.settingId == 1).valueArray,
  boundaries: state.boundaries,
  mapReference: state.mapReference()
})

const mapDispatchToProps = dispatch => ({
  boundaryCreateRequest: data => dispatch(boundaryCreateRequest(data)),
  photoUploadRequest: data => dispatch(photoUploadRequest(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(SaveBoundary)